<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>其他管理</el-breadcrumb-item>
        <el-breadcrumb-item>办公用品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请输入" style="margin-right: 0; width: 100%;">
              <el-option label="物品名称" value="name" checked></el-option>
              <el-option label="物品编号" value="office_no" checked></el-option>
              <el-option label="序列码" value="office_code" checked></el-option>
              <el-option label="规格型号" value="office_detail" checked></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="筛选：" prop="type">
          <el-col :span="3" style="margin-right: 20px;">
            <el-cascader v-model="form.cate_id_array" :options="officeTypeList" :props="{ expandTrigger: 'hover', checkStrictly: true }"
              @change="handleofficeChange" style="width: 100%;"></el-cascader>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.status" placeholder="当前状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="备用" value="0"></el-option>
              <el-option label="使用中" value="1"></el-option>
              <el-option label="已报废" value="2"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
            <el-checkbox label="物品编号"></el-checkbox>
            <el-checkbox label="物品名称"></el-checkbox>
            <el-checkbox label="物品类型"></el-checkbox>
            <el-checkbox label="序列码"></el-checkbox>
            <el-checkbox label="规格型号"></el-checkbox>
            <el-checkbox label="购买单价"></el-checkbox>
            <el-checkbox label="当前状态"></el-checkbox>
            <el-checkbox label="入库时间"></el-checkbox>
            <el-checkbox label="领用对象"></el-checkbox>
            <el-checkbox label="领用时间"></el-checkbox>
            <el-checkbox label="归还时间"></el-checkbox>
            <el-checkbox label="报废时间"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btnarea">
          <el-button icon="el-icon-plus" @click="true">新增</el-button>
          <el-button @click="exportOfficeListToExcel">导出数据</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row :row-class-name="tableRowClassName">
        <el-table-column prop="office_no" label="物品编号" header-align="center" align="center" min-width="100" v-if="check('物品编号')">
          <template slot-scope="scope">
            {{ scope.row.office_no ? scope.row.office_no : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="物品名称" header-align="center" align="center" min-width="100" v-if="check('物品名称')" />
        <el-table-column prop="category_name" label="物品类型" header-align="center" align="center" min-width="60" v-if="check('物品类型')">
          <template slot-scope="scope">
            {{ scope.row.category.category_name }}
          </template>
        </el-table-column>
        <el-table-column prop="office_code" label="序列码" header-align="center" align="center" min-width="80" v-if="check('序列码')" />
        <el-table-column prop="office_detail" label="规格型号" header-align="center" align="center" min-width="200" v-if="check('规格型号')" />
        <el-table-column prop="price" label="购买单价" header-align="center" align="center" min-width="60" v-if="check('购买单价')" />
        <el-table-column prop="price" label="当前状态" header-align="center" align="center" min-width="60" v-if="check('当前状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{ 'background': dd.stationeryStatus_c[scope.row.status].color }">
              <div class="word">{{ dd.stationeryStatus_c[scope.row.status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="入库时间" header-align="center" align="center" min-width="100" v-if="check('入库时间')" />
        <el-table-column prop="create_time" label="领用对象" header-align="center" align="center" min-width="100" v-if="check('领用对象')">
          <template slot-scope="scope">
            {{ Object.keys(scope.row.userOffice).length != 0 ? `${scope.row.userOffice.user.realname} ${scope.row.userOffice.user.en_name}` : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="receive_time" label="领用时间" header-align="center" align="center" min-width="100" v-if="check('领用时间')" >
          <template slot-scope="scope">
            {{ Object.keys(scope.row.userOffice).length != 0 ? `${scope.row.userOffice.receive_time}` : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="return_time" label="归还时间" header-align="center" align="center" min-width="100" v-if="check('归还时间')" >
          <template slot-scope="scope">
            {{ Object.keys(scope.row.userOffice).length != 0 ? `${scope.row.userOffice.return_time == '' ? '暂无' : scope.row.userOffice.return_time}` : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="scrap_time" label="报废时间" header-align="center" align="center" min-width="100" v-if="check('报废时间')">
          <template slot-scope="scope">
            {{ `${scope.row.scrap_time == '' ? '暂无' : scope.row.scrap_time}` }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" header-align="center" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleClick(scope.row)">编辑</el-link>
              <el-link type='primary' class="link" @click="handleView(scope.row)">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
// import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'stationery',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      userId: '',
      officeTypeList: [],
      checkList: [
        '物品编号',
        '物品名称',
        '物品类型',
        '序列码',
        '规格型号',
        '购买单价',
        '当前状态',
        '入库时间',
        '领用对象',
        '领用时间',
        '归还时间',
        '报废时间',
      ],
      yearList: [],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'name',
      },
      DepartList: [],
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.stationeryType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '物品类型',
          val: 'cate_id',
          value: this.form.cate_id,
          active: false,
        },
        {
          key: '当前状态',
          val: 'status',
          value: this.dd.stationeryStatus[this.form.status],
          active: !!this.form.status,
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {

  },
  mounted() {
    this.getStoreFn()
    this.getOfficeType()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    exportOfficeListToExcel() {
      window.location = api.exportOfficeListToExcel({
        ...this.form,
        [this.form.atype]: this.form.key,//搜索
      })
    },
    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },
    check(key) {
      return this.checkList.includes(key)
    },
    link(url) {
      this.$router.push(url)
    },
    getOfficeType() {
      this.$fly
        .post('apiOffice_getOfficeTypeDownList.html', {

        })
        .then((res) => {
          this.officeTypeList = res.length ? res : []
        })
    },
    handleClick(item) {
      this.$router.push({
        path: '/stationery/add',
        query: { id: item.id},
      })
    },

    handleView(item) {
      this.$router.push({
        path: '/stationery/view',
        query: { id: item.id},
      })
    },

    search() {
      this.p = 1
      store.commit('setStationeryData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.stationeryData).length != 0 ? store.state.stationeryData : this.form
      this.getList()
    },

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        [this.form.atype]: this.form.key,//搜索
      }
      api.getOfficeList(postData).then((res) => {
        this.itemList = res.itemList
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level
          this.userId = store.state.userId
        }, 200);
      })
    },

    removeTag(tag) {
      if (tag.val === 'cate_id') {
        this.form.cate_id_array = []
        this.form.cate_id = undefined
      } 
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      store.commit('setStationeryData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    handleCurrentChange(p) {
      this.p = p
      store.commit('setStationeryData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    tableRowClassName({ row }) {
      if (row.staff?.status === "2") {
        return "warning-row";
      }
    },
    handleofficeChange (e) {
      const trueId = e[e.length - 1]
      this.form.cate_id = trueId
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.expense {
  @extend %start;
  padding: 30px 0;

  >div {
    margin-right: 30px;
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

.description {
  @extend %start;

  div {
    &:nth-of-type(1) {
      width: 90px;
    }

    &:nth-of-type(2) {
      width: calc(100% - 150px);
    }

    &:nth-of-type(3) {
      width: 60px;
    }
  }
}

.form-title {
  line-height: 40px;
}

.vaca-form {
  el-form-item {
    .el-form-item__content {
      el-col-8 {
        margin-right: 5px;
      }
    }
  }
}
</style>
<style lang="scss">
.el-table tr {
  &.warning-row {
    // background: #d1d1d1;

    .el-table__cell {
      color: #aaa;
    }
  }
}
</style>